
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"25","height":"25"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M.202.658h24v24h-24z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M4.577 21.657l-1.4-1.4 10.25-10.25c-.3-.7-.341-1.491-.125-2.374.217-.884.692-1.675 1.425-2.375.884-.884 1.867-1.4 2.95-1.55 1.084-.15 1.967.116 2.65.8.684.683.95 1.566.8 2.65-.15 1.083-.666 2.066-1.55 2.95-.7.733-1.491 1.208-2.375 1.425-.883.216-1.675.175-2.375-.125l-1.25 1.25-1.4 1.45-7.6 7.55z"}})])])
          )
        }
      }
    